import * as React from 'react';
import { noop } from 'lodash';

import { useIntl } from 'react-intl-next';
import Avatar from '@atlaskit/avatar';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import messages from './messages';
import { UserAvatarContainer } from './styled';

export interface UserAvatarProps {
    avatarSrc?: string;
    isExpanded?: boolean;
}

const UserAvatar: React.FunctionComponent<UserAvatarProps> = ({ avatarSrc, isExpanded }) => {
    const { formatMessage } = useIntl();
    const avatarRef = React.useRef<HTMLDivElement>(null);
    // This is because the current avatar is not accepting aria props and also label does not change dynamically
    React.useEffect(() => {
        if (!avatarRef.current) {
            return;
        }
        avatarRef.current.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }, [isExpanded]);

    return (
        <UserAvatarContainer data-test-id="user-avatar-container">
            <Avatar
                onClick={noop}
                size="medium"
                appearance="circle"
                src={avatarSrc}
                borderColor={token('color.border.inverse', colors.N0)}
                name={formatMessage(messages.yourProfileAndSettings)}
                ref={avatarRef}
            />
        </UserAvatarContainer>
    );
};
export default UserAvatar;
